module.exports = __webpack_public_path__ + "img/face-sad-tear.96f7f1fc.svg";